/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect, useRef } from 'react';
import { FitinsurAPI, MessageCenter } from 'utils';
import { SearchField, InputField } from '@fitinsur/components';

import {
  Dialog,
  DialogBody,
  DialogText,
  DialogCancel,
  DialogConfirm,
} from './styles';
import { Field, Form, Formik } from 'formik';
import Col from 'components/Grid/Col';
import Row from 'components/Grid/Row';

const mc = new MessageCenter();

export default function DialogComponent({
  show,
  setShowModal,
  initialSearchList,
  idParty,
  handleSaveNewContact
}) {
  const [currentContact, setCurrentContact] = useState({
    idPersonContact: '',
    idContact: '',
    nameContact: '',
    personContactDepartment: '',
    email: '',
    jobTitle: '',
    country: '',
    contactNumber: ''
  });
  const [searchList, setSearchList] = useState([])
  const [searchValue, setSearchValue] = useState('');

  const myRef = useRef();
  const formikRef = useRef(null);

  useEffect(() => {
    if (initialSearchList.length > 0) {
      const filterList = initialSearchList
        .map(contact => ({ name: contact.idPersonContact, value: contact.nameContact || contact.name }))
        .filter((item) => item.value.toLowerCase().includes(searchValue.toLowerCase()));
      return setSearchList(filterList);
    }
  }, [searchValue, initialSearchList])

  const handleSave = async () => {
    try {
      handleSaveNewContact(idParty, currentContact.idContact);
      setShowModal(false);
      resetContact();
    } catch (error) {
      mc.error(error.message);
    }
  }

  const handleSelectContact = (selectedValue) => {
    const { name: idPersonContact } = selectedValue;
    const contact = initialSearchList.find((c) => c.idPersonContact === idPersonContact);

    setCurrentContact({
      idPersonContact: idPersonContact,
      idContact: contact.idContact,
      nameContact: contact.nameContact,
      personContactDepartment: contact.personContactDepartment,
      email: contact.email,
      jobTitle: contact.jobTitle,
      country: contact.country,
      contactNumber: contact.contactNumber
    })

    const objectKeys = Object.keys(contact);
    objectKeys.forEach((key) => {
      formikRef.current.setFieldValue(key, contact[key]);
    })
  }

  const resetContact = () => {
    setCurrentContact({
      idPersonContact: '',
      idContact: '',
      nameContact: '',
      personContactDepartment: '',
      email: '',
      jobTitle: '',
      country: '',
      contactNumber: ''
    })

    formikRef.current.resetForm();
  }

  return (
    <Dialog canShow={show} >
      <DialogBody ref={myRef}>
        <Formik
          innerRef={formikRef}
          initialValues={{
            nameContact: currentContact.nameContact,
            personContactDepartment: currentContact.personContactDepartment,
            email: currentContact.email,
            jobTitle: currentContact.jobTitle,
            country: currentContact.country,
            contactNumber: currentContact.contactNumber
          }}
        >
          {formikProps => (
            <Form>
              <Row>
                <Col style={{ padding: '0' }}>
                  <DialogText>*Full Name</DialogText>
                </Col>
                <Col style={{ padding: '0' }}>
                  <Field
                    smallInput={false}
                    formatTextHtml
                    name="nameContact"
                    component={SearchField}
                    onShowChatInsurer
                    value={formikProps.values.searchInternalMessage}
                    initSearchList={searchList}
                    searchRequest={(searchQuery) => setSearchValue(searchQuery)}
                    filterModal
                    onSearchSelect={handleSelectContact}
                  />
                </Col>
              </Row>
              <Row>
                <Col style={{ padding: '0' }}>
                  <DialogText>Contact Department</DialogText>
                </Col>
                <Col style={{ padding: '0' }}>
                  <Field
                    name="personContactDepartment"
                    component={InputField}
                    value={formikProps.values.personContactDepartment}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col style={{ padding: '0' }}>
                  <DialogText>Job Title</DialogText>
                </Col>
                <Col style={{ padding: '0' }}>
                  <Field
                    name="jobTitle"
                    component={InputField}
                    value={formikProps.values.jobTitle}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col style={{ padding: '0' }}>
                  <DialogText>Email ID</DialogText>
                </Col>
                <Col style={{ padding: '0' }}>
                  <Field
                    name="email"
                    component={InputField}
                    value={formikProps.values.email}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col style={{ padding: '0' }}>
                  <DialogText>Country</DialogText>
                </Col>
                <Col style={{ padding: '0' }}>
                  <Field
                    name="country"
                    component={InputField}
                    value={formikProps.values.country}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col style={{ padding: '0' }}>
                  <DialogText>Contact Number</DialogText>
                </Col>
                <Col style={{ padding: '0' }}>
                  <Field
                    name="contactNumber"
                    component={InputField}
                    value={formikProps.values.contactNumber}
                    disabled={true}
                  />
                </Col>
              </Row>
              <DialogCancel
                onClick={() => { resetContact(); setShowModal(false) }}
                type="button"
              >
                Cancel
              </DialogCancel>
              <DialogConfirm
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleSave();
                }}
              >
                Confirm
              </DialogConfirm>
            </Form>
          )}
        </Formik>
      </DialogBody>
    </Dialog>
  );
}